var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFour8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#186639"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18V11.3333C22 10.9797 21.8595 10.6406 21.6095 10.3905C21.3594 10.1405 21.0203 10 20.6667 10H11.3333C10.9797 10 10.6406 10.1405 10.3905 10.3905C10.1405 10.6406 10 10.9797 10 11.3333V20.6667C10 21.0203 10.1405 21.3594 10.3905 21.6095C10.6406 21.8595 10.9797 22 11.3333 22H18M22 18V18.1147C21.9999 18.4683 21.8594 18.8073 21.6093 19.0573L19.0573 21.6093C18.8073 21.8594 18.4683 21.9999 18.1147 22H18M22 18H19.3333C18.9797 18 18.6406 18.1405 18.3905 18.3905C18.1405 18.6406 18 18.9797 18 19.3333V22M12.6667 12.6667H19.3333M12.6667 15.3333H19.3333M12.6667 18H15.3333",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour8);
export default __webpack_public_path__ + "static/media/four 8.9dc750084852b21c3da3cb3ae7be9604.svg";
export { ForwardRef as ReactComponent };